import {cloneDeep} from 'lodash';

export const onValidationError = (e, mc, formikRef, questionnaire, groupQuestionnaires) => {
  mc.error('Please complete all required fields to proceed.')
  const allQuestions = cloneDeep(questionnaire);
  const groupsQuestionnaires = cloneDeep(groupQuestionnaires);
  groupsQuestionnaires.map(questionnaire => questionnaire.map(question => allQuestions.push(question)));

  let firstErrorKey = null;
  try {
    for (const question of allQuestions) {
      if (!formikRef.current.errors || !formikRef.current.errors[question.key]) continue;
      formikRef.current.setFieldError(question.key, null);
    }

    if(!e.inner.length) mc(e.message)

    if(e.message === 'Endorsement message is required') {
      formikRef.current.setFieldError('endorsementMessage', `* Required Field`)
      mc.error(e.message);
    };

    e.inner.map(({ message, path }) => {
      const question = allQuestions.find(question => question.key === path);
      if (question) mc.error(`The Field ${question.dsQuestion} is Required`);
      if (e.message === "Email inválido") formikRef.current.setFieldError(question.key, `* Email inválido`);
      else formikRef.current.setFieldError(question.key, `* Required Field`);
      if (!firstErrorKey) firstErrorKey = question.key;
    })

    if (firstErrorKey) {
      const elements = global.window.document.getElementsByName(firstErrorKey);
      if (elements?.length) {
        setTimeout(() => elements[0].scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'start' }), 300);
      }
    }
  } catch (e) {
    console.log('onValidationError catch', e)
  }
}